import store from "@/store";

function defaultParams() {
  return { hash: store.getters["cart/cacheBurst"] };
}
export { defaultParams };
